module.exports = __webpack_public_path__ + "static/media/bottle_250.5f4b084f.png";